import { inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { KeycloakService } from 'keycloak-angular';
import { LoginService } from './login.service';

import { DEPLOY_PREFIX } from '@frontend/util-api-data';

@Injectable({
  providedIn: 'root',
})
export class LoginServiceSchueco implements LoginService {
  private keycloakService = inject(KeycloakService);

  document = inject(DOCUMENT);
  private deployPrefix = inject(DEPLOY_PREFIX);

  async login(): Promise<boolean> {
    try {
      await this.keycloakService.login({
        redirectUri:
          window.location.origin +
          this.deployPrefix +
          window.location.pathname +
          window.location.search +
          window.location.hash,
      });
      return true;
    } catch {
      return false;
    }
  }

  async logout(): Promise<void> {
    try {
      const currentLang = window.location.pathname.split('/')[1] || '';
      const currentUrl = `${window.location.origin}/${currentLang}`;
      this.keycloakService.logout(currentUrl);
    } catch (error) {
      console.error('Logout failed', error);
    }
  }

  async isLoggedIn(): Promise<boolean> {
    try {
      return await this.keycloakService.isLoggedIn();
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  async getUserInfo() {
    try {
      return await this.keycloakService.getKeycloakInstance().loadUserInfo();
    } catch (error) {
      console.error(error);
      return 'error getting userinfo';
    }
  }
}
